import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Suspense, lazy } from "react";
import Navbar from "./components/Navbar/Navbar";
import NotFound from "./pages/NotFound/NotFound";
import Loader from "./pages/loader/Loader";
import Privacy from "./pages/Privacy Policy/Privacy";
import Terms from "./pages/Terms And Condition/Terms";
import Cancellation from "./pages/Cancellation And Refund Policy/Cancellation";
import Service from "./pages/Service Delivery Policy/Service";
import Cookie from "./pages/Cookie Policy/Cookie";
import FAQ from "./pages/FAQ/FAQ";
import Sitemap from "./pages/Sitemap/Sitemap";

const Home = lazy(() => import("./pages/Home/Home"));
const About = lazy(() => import("./pages/About/About"));
const Contact = lazy(() => import("./pages/Contact/Contact"));
const Services = lazy(() => import("./pages/Services/Services"));
const Plans = lazy(() => import("./pages/Plans/Plans"));
const Careers = lazy(() => import("./pages/Careers/Careers"));
const InvestorRelation = lazy(() => import("./pages/InvestorRelation/InvestorRelation"));
const Partner = lazy(() => import("./pages/Partner/Partner"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <Navbar />,
    errorElement: <NotFound />,
    children: [
      {
        path: "/",
        element: (
          <Suspense fallback={<div className="loader-container"><Loader /></div>}>
            <Home />
          </Suspense>
        ),
      },
      {
        path: "/about",
        element: (
          <Suspense fallback={<div className="loader-container"><Loader /></div>}>
            <About />
          </Suspense>
        ),
      },
      {
        path: "/contact",
        element: (
          <Suspense fallback={<div className="loader-container"><Loader /></div>}>
            <Contact />
          </Suspense>
        ),
      },
      {
        path: "/services",
        element: (
          <Suspense fallback={<div className="loader-container"><Loader /></div>}>
            <Services />
          </Suspense>
        ),
      },
      {
        path: "/plans",
        element: (
          <Suspense fallback={<div className="loader-container"><Loader /></div>}>
            <Plans />
          </Suspense>
        ),
      },
      {
        path: "/careers",
        element: (
          <Suspense fallback={<div className="loader-container"><Loader /></div>}>
            <Careers />
          </Suspense>
        ),
      },
      {
        path: "/investor-relation",
        element: (
          <Suspense fallback={<div className="loader-container"><Loader /></div>}>
            <InvestorRelation />
          </Suspense>
        ),
      },
      {
        path: "/partner",
        element: (
          <Suspense fallback={<div className="loader-container"><Loader /></div>}>
            <Partner />
          </Suspense>
        ),
      },
      {
        path: "/privacy-policy",
        element: (
          <Suspense fallback={<div className="loader-container"><Loader /></div>}>
            <Privacy />
          </Suspense>
        )
      },
      {
        path: "/terms-and-conditions",
        element: (
          <Suspense fallback={<div className="loader-container"><Loader /></div>}>
            <Terms />
          </Suspense>
        )
      },
      {
        path: "/cancellation-refund-policy",
        element: (
          <Suspense fallback={<div className="loader-container"><Loader /></div>}>
            <Cancellation />
          </Suspense>
        )
      },
      {
        path: "/service-delivery-policy",
        element: (
          <Suspense fallback={<div className="loader-container"><Loader /></div>}>
            <Service />
          </Suspense>
        )
      },
      {
        path: "/cookie-policy",
        element: (
          <Suspense fallback={<div className="loader-container"><Loader /></div>}>
            <Cookie />
          </Suspense>
        )
      },
      {
        path: "/faq",
        element: (
          <Suspense fallback={<div className="loader-container"><Loader /></div>}>
            <FAQ />
          </Suspense>
        )
      },
      {
        path: "/sitemap",
        element: (
          <Suspense fallback={<div className="loader-container"><Loader /></div>}>
            <Sitemap />
          </Suspense>
        )
      },
    ],
  },
]);

function App() {
  return (
    <div>
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
